export default "__VITE_ASSET__CqFV1lrO__"